"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCyclesText = void 0;
const react_1 = __importDefault(require("react"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const cycles_1 = require("../../formatters/cycles");
exports.default = react_1.default.memo(CyclesContent);
function formatCyclesText(amount, sentTo, them) {
    return cycles_1.formatCycles(amount) + (sentTo ? " sent to " : " received from ") + (them !== null && them !== void 0 ? them : "unknown");
}
exports.formatCyclesText = formatCyclesText;
const useStyles = makeStyles_1.default((theme) => ({
    cycles: {
        padding: "0 12px",
        display: "flex",
        alignItems: "center"
    },
    icon: {
        fontSize: 50,
        marginRight: 12
    }
}));
function CyclesContent(props) {
    const classes = useStyles(props);
    return (react_1.default.createElement("div", { className: classes.cycles },
        react_1.default.createElement(Typography_1.default, { className: classes.icon }, "\uD83C\uDF89"),
        react_1.default.createElement(Typography_1.default, { variant: "body1" }, formatCyclesText(props.content.amount, props.sentByMe, props.theirUsername))));
}
